import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './styles.css'
import MailForm from "../components/MailForm";

class SendEmail extends Component {
    static contextTypes = {api: PropTypes.object};
    render(){
        return(
            <div className="container-fluid SendEmail">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-content">
                                <MailForm creating/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ( { api: {loadingIds } } )=>{
    return {loadingIds}
};

export default connect(mapStateToProps)(SendEmail);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/SendEmail/index.jsx